export const API_PATH = {
  PARTS: 'backoffice/parts/',
  WORKOUTS: 'backoffice/workouts/',
  CHALLENGES: 'backoffice/challenges/',
  CHALLENGES_CONDITIONS: 'backoffice/challenge-conditions/',
  POST_CHALLENGES_CONDITIONS: 'backoffice/challenge-conditions/bulk/',
  CHALLENGES_ROUTINES: 'backoffice/challenge-routines/',
  POST_CHALLENGES_ROUTINES: 'backoffice/challenge-routines/bulk/',
  POST_CHALLENGES_ROUTINES_V2: 'v2/backoffice/challenges',
  TAGS_PURPOSES: 'backoffice/challenges/purposes',
  TAGS_CATEGORIES: 'backoffice/challenges/categories',
  TAGS: 'backoffice/challenges/tags/',
  POST_WORKOUT_MIGRATE: 'backoffice/workouts/migrate/',
  ME: 'profile/me',
  COACHES: 'v2/backoffice/coaches/',
  COACHES_SETTLEMENTS: 'v2/backoffice/coaches/settlements',
  COACHES_SETTLEMENTS2: 'v2/backoffice/coaches/settlements',
  USER_FIND: 'friend/find_friends/',
  COACH_CHALLENGE: (coach_id: number) =>
    `v2/backoffice/coaches/${coach_id}/challenges`,
  COACHES_SETTLEMENTS_BATCHES: (coach_user_id: number) =>
    `v2/backoffice/coaches/settlements/batches/${coach_user_id}`,
  COACHES_SETTLEMENTS_CHALLENGES_DETAIL: (challengeId: number) =>
    `v2/backoffice/coaches/settlements/challenges/${challengeId}/detail`,

  COACHES_SETTLEMENTS_CHALLENGES_DETAIL_SALE: (challengeId: number) =>
    `v2/backoffice/coaches/settlements/challenges/${challengeId}/detail/sales`,
  ANNOUNCEMENT: 'v2/backoffice/announcement',
  ANNOUNCEMENT_DETAIL: (id: number) => `v2/backoffice/announcement/${id}`,
  FROM_STORE: 'v2/backoffice/coaches/settlement/from-store',
};
